import { get, post, patch, deleteRequest } from 'utils/api';

export const getOperatorMasters = (data = {}) => {
  return get('/operator-masters', data);
};

export const getOperatorMasterById = (id) => {
  return get(`/operator-masters/${id}`);
};

export const addOperatorMaster = (data) => {
  return post('/operator-masters', data);
};

export const updateOperatorMaster = (data) => {
  const id = data.id || data._id;
  const body = { ...data };
  delete body.id;
  delete body._id;
  return patch(`/operator-masters/${id}`, body);
};

export const deleteOperatorMaster = (id) => {
  return deleteRequest(`/operator-masters/${id}`);
};

export const operatorMaster = {
  getOperatorMasters,
  getOperatorMasterById,
  addOperatorMaster,
  updateOperatorMaster,
  deleteOperatorMaster,
};
